// Add your custom JS here.

jQuery(document).ready(function ($) {

    //if (window.location.pathname !== "/") {

    setTimeout(function () {

        $('.animation-menu').css('animation', 'box-animation 2s linear forwards')

    }, 1000)
    //}



    $('.offcanvas').addClass('offcanvas-animation')


    $('.custom-offcanvas-fire').on('click', function () {

        var target = $(this).data('sm-target');

        $('#' + target).addClass('show');

    })


    $('.close-offcanvas').on('click', function () {

        var target = $(this).parent();

        target.removeClass('show');

    })

    // Footer fijo revelado (efecto parallax): el contenido (.wrapper, con z-index
    // alto y fondo solido) se levanta al hacer scroll y descubre el footer fijo que
    // hay detras. Se reserva en los wrappers un margin-bottom = altura del footer
    // para crear el hueco por el que se ve.
    //
    // Cuando el footer es MAS ALTO que la ventana (tipico en movil) no cabe entero.
    // El desplazamiento se limita a `oculto` (lo que sobra), lo que produce dos fases
    // naturales de arriba a abajo:
    //  1. Parallax: mientras el contenido se desliza por encima, el footer esta quieto
    //     (borde superior alineado con el viewport) mostrando su parte de arriba.
    //  2. Scroll: una vez el contenido ya ha subido del todo, el footer se desplaza
    //     para revelar su parte baja hasta alinear su borde inferior con el final.
    // Cuando cabe, se deja pegado abajo (reveal clasico, sin transform).
    var $footer = $('.wrapper-footer');
    var footerEl = $footer.get(0);
    var $wrappers = $('.wrapper:not(.wrapper-footer)');

    var AIRE = 50;        // px extra reservados para que el footer respire
    var footerHeight = 0; // altura del footer (+ AIRE), cacheada
    var oculto = 0;       // px del footer que no caben en el viewport (footerH - vh)

    // Coloca el footer segun el scroll (solo interviene si no cabe entero).
    function colocarFooter() {
        if (!footerEl) return;

        if (oculto <= 0) {
            footerEl.style.transform = ''; // cabe: reveal clasico pegado abajo
            return;
        }

        // translateY = px que faltan para llegar al final del scroll, acotado a
        // `oculto`. Mientras faltan mas de `oculto` px, el footer queda quieto con su
        // borde superior en el tope (fase parallax); en los ultimos `oculto` px se
        // desplaza hasta 0 para revelar su parte baja (fase scroll).
        var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        var scrollY = window.pageYOffset || document.documentElement.scrollTop;
        var t = Math.min(oculto, Math.max(0, maxScroll - scrollY));

        footerEl.style.transform = 'translateY(' + t + 'px)';
    }

    // Remide y reserva el hueco. Se llama cuando cambian tamanos: el form de
    // newsletter (tnp) y otros assets cargan despues de `ready()`, por lo que una
    // unica medida inicial queda desfasada.
    function medirFooter() {
        if (!footerEl) return;
        footerHeight = $footer.outerHeight() + AIRE; // +aire para que no quede pegado
        oculto = footerHeight - window.innerHeight;
        $wrappers.css('margin-bottom', footerHeight + 'px');
        colocarFooter();
    }

    medirFooter();

    // Remedimos tras la carga completa (imagenes/fuentes) y en cada resize/rotacion.
    $(window).on('load resize', medirFooter);

    // El desplazamiento se recalcula en cada scroll, limitado con requestAnimationFrame.
    var ticking = false;
    $(window).on('scroll', function () {
        if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(function () {
                colocarFooter();
                ticking = false;
            });
        }
    });

    // ResizeObserver: si el footer cambia de alto por contenido que llega tarde
    // (newsletter tnp, embeds), volvemos a medir. El transform no altera el tamano
    // de layout del footer, por lo que no se realimenta.
    if (footerEl && 'ResizeObserver' in window) {
        new ResizeObserver(medirFooter).observe(footerEl);
    }

    /*****************      Buscador noticias    ****************************/

    $('.listado-noticias .card-title').each(function () {

        var title = $(this)[0];
        $clamp(title, { clamp: 2 });

    })

    let selectedCategory = '';
    let selectedSubcategory = '';
    let currentPage = 1;

    $('.btn-category').each(function () {
        const buttonCategory = $(this).data('category'); // Get the category from the button
        const activeCategory = getCookie('filter_category') || 'all'; // Retrieve the active category, default to 'all'

        if (buttonCategory === activeCategory) {
            $(this).removeClass('btn-light').addClass('btn-dark'); // Mark active button
        } else {
            $(this).removeClass('btn-dark').addClass('btn-light'); // Reset inactive buttons
        }
    });

    $('.btn-subcategory').each(function () {
        const buttonSubcategory = $(this).data('subcategory'); // Get the category from the button
        const activeSubcategory = getCookie('filter_subcategory') || 'all'; // Retrieve the active category, default to 'all'

        if (buttonSubcategory === activeSubcategory) {
            $(this).removeClass('btn-light').addClass('btn-dark'); // Mark active button
        } else {
            $(this).removeClass('btn-dark').addClass('btn-light'); // Reset inactive buttons
        }
    });



    function filterNews(paged = 1, scrollToFeed = false) {
        var search = $('.input-buscador').val();
        selectedCategory = getCookie('filter_category');

        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: {
                action: 'search_news_callback',
                search: search,
                category: selectedCategory,
                subcategory: selectedSubcategory,
                paged: paged,
            },
            success: function (response) {

                $('#pagination').remove();

                $('.listado-noticias .row.g-0').html(response);

                $('.new-pagination').html($(response).find('#pagination').html());

                $('.listado-noticias .card-title').each(function () {

                    var title = $(this)[0];
                    $clamp(title, { clamp: 2 });

                });

                if ($('.new-pagination').length > 0) {
                    $('.new-pagination').show();
                }

                if (scrollToFeed) {
                    const feedPosition = $('.buscador-noticias').offset().top;
                    $('html, body').animate({ scrollTop: feedPosition }, 'fast');
                }
            },
            error: function () {
                console.log('Error fetching news.');
            }
        });
    }

    $('.input-buscador').on('input', function () {
        currentPage = 1;
        var search = $('.input-buscador').val();
        setCookie('filter_search', search, 1);
        filterNews(currentPage);
    });

    $(document).on('click', '.btn-buscador button', function () {
        $('.btn-buscador button').removeClass('btn-dark').addClass('btn-light');
        $(this).removeClass('btn-light').addClass('btn-dark');

        selectedCategory = $(this).data('category');
        currentPage = 1;

        setCookie('filter_category', selectedCategory, 1);
        selectedSubcategory = 'all';
        setCookie('filter_subcategory', selectedSubcategory, 1);

        filterNews(currentPage);
    });


    function setCookie(nombre, valor, dias) {
        const d = new Date();
        d.setTime(d.getTime() + (dias * 24 * 60 * 60 * 1000));
        const expiracion = "expires=" + d.toUTCString();
        document.cookie = `${nombre}=${valor};${expiracion};path=/`;
    }

    function getCookie(nombre) {
        const name = nombre + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookies = decodedCookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let c = cookies[i].trim();
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    var currentPath = window.location.pathname;

    // Only clear cookies if we're NOT on /noticias page
    if (!currentPath.includes('/noticias')) {
        setCookie('filter_search', '', -1);
        setCookie('filter_category', '', -1);
        setCookie('filter_subcategory', '', -1);
    }

    $(document).on('click', '.btn-subcategory', function () {
        $('.btn-subcategory').removeClass('btn-dark').addClass('btn-light');
        $(this).removeClass('btn-light').addClass('btn-dark');

        selectedSubcategory = $(this).data('subcategory');
        setCookie('filter_subcategory', selectedSubcategory, 1);
        currentPage = 1;
        filterNews(currentPage);
    });


    function fetchSubcategories(categorySlug) {
        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: {
                action: 'get_subcategories_by_parent',
                category_slug: categorySlug
            },
            success: function (response) {
                $('#subcategory-buttons').html(response.subcategories_html);
                $('#subcategory-buttons').prepend('<button type="button" id="ver-todos-noticias" class="btn btn-dark btn-subcategory me-1" data-subcategory="all">Ver todos</button>');

                resetSubcategoryButtons();
            },
            error: function () {
                console.log('Error fetching subcategories.');
            }
        });
    }

    function resetSubcategoryButtons() {
        $('.btn-subcategory').not('#ver-todos-noticias').removeClass('btn-dark').addClass('btn-light');
        $('.btn-subcategory#ver-todos-noticias').removeClass('btn-light').addClass('btn-dark');
    }

    $(document).on('click', '.btn-category', function () {
        $('.btn-category').removeClass('btn-dark').addClass('btn-light');
        $(this).removeClass('btn-light').addClass('btn-dark');

        const category = $(this).data('category');

        if (category === 'all') {
            fetchAllSubcategories();
        } else {
            fetchSubcategories(category);
        }
    });

    function fetchAllSubcategories() {
        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: {
                action: 'get_all_subcategories'
            },
            success: function (response) {
                $('#subcategory-buttons').html(response.subcategories_html);
                $('#subcategory-buttons').prepend('<button type="button" id="ver-todos-noticias" class="btn btn-dark btn-subcategory me-1" data-subcategory="all">Ver todos</button>');

                resetSubcategoryButtons();
            },
            error: function () {
                console.log('Error fetching all subcategories.');
            }
        });
    }

    $(document).on('click', '.btn-subcategory', function () {
        const subcategorySlug = $(this).data('subcategory');

        $('.btn-subcategory').removeClass('btn-dark').addClass('btn-light');
        $(this).removeClass('btn-light').addClass('btn-dark');


    });



    /********************* Buscador agenda **************************************/

    function filterEvents() {
        const category = $('.btn-subcategory.btn-dark').data('subcategory') || 'all';
        const search = $('.input-buscador').val();

        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: {
                action: 'load_filtered_events',
                category: category,
                search: search,
            },
            success: function (response) {
                $('.listado-eventos .row').html(response);
            },
            error: function () {
                $('.listado-eventos .row').html('<p>Error loading events.</p>');
            }
        });
    }

    $('.btn-subcategory').on('click', function () {
        $('.btn-subcategory').removeClass('btn-dark').addClass('btn-light');
        $(this).removeClass('btn-light').addClass('btn-dark');
        filterEvents();
    });

    $('.input-buscador').on('input', function () {
        const searchTerm = $(this).val().trim();

        if (searchTerm === '') {
            $('.main-evento').show();
        } else {
            filterEvents();
            $('.main-evento').hide();
        }
    });


    $('.small-card').on('click', function () {
        const postId = $(this).data('id');

        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: {
                action: 'get_event_details',
                post_id: postId
            },
            success: function (response) {
                if (response.success) {
                    console.log('Data: ' + response.data);
                    const data = response.data;
                    $('.main-event-card .card-body h3').text(data.title);
                    $('.main-event-card .event-content').html(data.description);
                    $('.main-event-card .location-evento .tipo-evento-text').text(data.location);
                    $('.main-event-card .location-evento').attr('href', data.google_maps);
                    $('.main-event-card .tipo-evento').text('MODALIDAD ' + data.type);
                    $('.main-event-info .mas-info-event a').attr('href', data.more_info);
                    $('.main-event-info .event-inscription a').attr('href', data.registration);
                    $('.main-event-info .event-actions a').attr('href', data.google_calendar);
                    $('.main-event-card .fecha-evento').text(data.date); // Display date
                } else {
                    console.log('Error: ' + response.data);
                }
            },

        });
    });


    /******* Video asociacion single  ********************/

    var iframe = $('.iframe-container');
    var expandedHeight = 726;
    var initialHeight = 334;
    var middleOffset = (expandedHeight - initialHeight) / 2;

    if (iframe.length) {
        $(window).on('scroll', function () {
            var iframeOffset = iframe.offset().top;
            var windowHeight = $(window).scrollTop() + $(window).height();


            if (iframeOffset < windowHeight && iframeOffset + iframe.height() > $(window).scrollTop()) {

                iframe.stop().animate({
                    height: expandedHeight,
                    top: -middleOffset
                }, 726);
            } else {

                iframe.stop().animate({
                    height: initialHeight,
                    top: 0
                }, 726);
            }
        });

        $(window).trigger('scroll');
    }


    /************   Login/Register Page      ************/

    $('#info-correo').on('click', function () {
        $('.info-correo').toggle();
    });

    $('#info-disease').on('click', function () {
        $('.info-disease').toggle();
    });

    $('#info-logo').on('click', function () {
        $('.info-logo').toggle();
    });

    $('#info-whatsapp').on('click', function () {
        $('.info-whatsapp').toggle();
    });

    jQuery('.register-btn').click(function (e) {
        e.preventDefault();
        jQuery('.modulo-registro').removeClass('hidden');
        jQuery('.modulo-login').addClass('hidden');
    });

    jQuery('.step-1-btn').click(function (e) {
        e.preventDefault();

        let allFilled = true;

        function validateField(inputField, errorMsgDiv, errorMessage) {
            if (inputField.val().trim() === '') {
                allFilled = false;
                errorMsgDiv.html(errorMessage).show();
            } else {
                errorMsgDiv.html('').hide();
            }
        }

        jQuery('.step-1 :input[required]').each(function () {
            var inputField = jQuery(this);
            var errorMsgDiv = inputField.closest('div').find('.error-msg');

            if (inputField.val().trim() === '') {
                allFilled = false;
                errorMsgDiv.html('Este campo es obligatorio.').show();
            } else {
                errorMsgDiv.html('').hide();
            }
        });

        var password = jQuery('#new_password').val().trim();
        var confirmPassword = jQuery('#new_confirm_password').val().trim();

        var passwordError = jQuery('#new_password').closest('div').find('.error-msg');
        var confirmPasswordError = jQuery('#new_confirm_password').closest('div').find('.error-msg');

        validateField(jQuery('#new_password'), passwordError, 'Este campo es obligatorio.');
        validateField(jQuery('#new_confirm_password'), confirmPasswordError, 'Este campo es obligatorio.');

        const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

        if (!passwordRegex.test(password)) {
            allFilled = false;
            passwordError.html('La contraseña debe tener al menos 8 caracteres, una letra mayúscula y un símbolo.').show();
        }

        if (password !== confirmPassword) {
            allFilled = false;
            confirmPasswordError.html('Las contraseñas no coinciden.').show();
        }

        var email = jQuery('#new_email').val().trim();
        var confirmEmail = jQuery('#new_confirm_email').val().trim();
        var emailError = jQuery('#new_email').closest('div').find('.error-msg');
        var confirmEmailError = jQuery('#new_confirm_email').closest('div').find('.error-msg');

        var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (!emailPattern.test(email)) {
            allFilled = false;
            emailError.html('El formato del correo electrónico no es válido.').show();
        } else {
            emailError.html('').hide();
        }

        if (!emailPattern.test(confirmEmail)) {
            allFilled = false;
            confirmEmailError.html('El formato del correo electrónico no es válido.').show();
        } else {
            confirmEmailError.html('').hide();
        }

        if (email === confirmEmail && email !== '') {
            allFilled = false;
            confirmEmailError.html('Los correos electrónicos no pueden ser iguales.').show();
        }

        if (allFilled) {
            jQuery('.step-1').addClass('hidden');
            jQuery('.step-2').removeClass('hidden');

            jQuery('.first-step').removeClass('active');
            jQuery('.second-step').addClass('active');

            jQuery('.box-1').addClass('muted');
        }
    });

    jQuery('.step-2-btn').click(function (e) {
        e.preventDefault();

        let allFilled = true;

        jQuery('.step-2 :input[required]').each(function () {
            let inputField = jQuery(this);
            let errorMsgDiv = inputField.closest('div').find('.error-msg');

            if (inputField.is('select')) {
                if (!inputField.val()) {
                    allFilled = false;
                    errorMsgDiv.html('Este campo es obligatorio.').show();
                } else {
                    errorMsgDiv.html('').hide();
                }

            } else if (inputField.is(':file')) {

                if (!inputField[0].files || inputField[0].files.length === 0) {
                    allFilled = false;
                    jQuery('.file-error').html('Por favor, selecciona un archivo.').show();
                } else {
                    jQuery('.file-error').html('').hide();
                }

            } else if (inputField.val().trim() === '') {
                allFilled = false;
                errorMsgDiv.html('Este campo es obligatorio.').show();
            } else {
                errorMsgDiv.html('').hide();
            }
        });

        if (allFilled) {
            jQuery('.step-2').addClass('hidden');
            jQuery('.step-3').removeClass('hidden');

            jQuery('.second-step').removeClass('active');
            jQuery('.third-step').addClass('active');

            jQuery('.box-2').addClass('muted');
        }
    });

    $('#new_logo').change(function (event) {
        const file = event.target.files[0];

        let inputField = jQuery(this);
        let errorMsgDiv = jQuery('.file-error');

        if (file && (file.type === "image/png" || file.type === "image/jpg")) {
            const reader = new FileReader();

            reader.onload = function (e) {
                $('#image-preview').attr('src', e.target.result).show();
                $('#preview-text').show();
            };

            reader.readAsDataURL(file);
        } else {
            errorMsgDiv.html('Solo se admite formato PNG o JPG.').show();
        }
    });

    jQuery('.step-2-prev-btn').click(function (e) {
        e.preventDefault();
        jQuery('.step-2').addClass('hidden');
        jQuery('.step-1').removeClass('hidden');

        jQuery('.first-step').addClass('active');
        jQuery('.second-step').removeClass('active');

        jQuery('.box-1').removeClass('muted');
    });

    jQuery('.step-3-prev-btn').click(function (e) {
        e.preventDefault();
        jQuery('.step-3').addClass('hidden');
        jQuery('.step-2').removeClass('hidden');

        jQuery('.second-step').addClass('active');
        jQuery('.third-step').removeClass('active');

        jQuery('.box-2').removeClass('muted');
    });

    jQuery('.close-btn').click(function (e) {
        e.preventDefault();
        jQuery('.modulo-registro').addClass('hidden');
        jQuery('.step-1').removeClass('hidden');
        jQuery('.step-2').addClass('hidden');
        jQuery('.step-3').addClass('hidden');
        jQuery('.modulo-login').removeClass('hidden');

        jQuery('.modulo-registro :input').val('');
        jQuery('.modulo-registro .error-msg').html('');
    });

    const digitBoxes = $('.digit-box');

    digitBoxes.on('input', function () {
        const currentBox = $(this);
        const currentIndex = currentBox.data('index');

        if (currentBox.val().length === 1 && currentIndex < 5) {
            // Move to the next box if current box is filled and not the last one
            digitBoxes.eq(currentIndex + 1).focus();
        } else if (currentBox.val().length === 0 && currentIndex > 0) {
            // Move back if box is empty after deletion
            digitBoxes.eq(currentIndex - 1).focus();
        }
    });

    digitBoxes.on('keydown', function (event) {
        // Allow only numbers and backspace
        if (!((event.key >= '0' && event.key <= '9') || event.key === 'Backspace')) {
            event.preventDefault();
        }
    });


    /************* Page area privada *************/

    $('.close-verificacion').click(function (e) {
        $('.banner-verificacion').css('display', 'none');
    });

    $('.close-verificado').click(function (e) {
        $('.banner-verificado').css('display', 'none');
    });

    $('.close-completa-registro').click(function (e) {
        $('.banner-completa-registro').css('display', 'none');
    });

    $('.close-premios').click(function (e) {
        $('.banner-premios').css('display', 'none');
    });

    $('.close-votos').click(function (e) {
        $('.banner-votos').css('display', 'none');
    });

    $('.close-sugerencia-aceptada').click(function (e) {
        $('.banner-sugerencia-aceptada').css('display', 'none');
    });

    $('.close-sugerencia-descartada').click(function (e) {
        $('.banner-sugerencia-descartada').css('display', 'none');
    });

    $('.close-sugerencia-publicada').click(function (e) {
        $('.banner-sugerencia-publicada').css('display', 'none');
    });

    jQuery("#abrir-presencia").click(function () {
        jQuery(".presencia-btn-section").css("max-height", "2000px");
        jQuery("#abrir-presencia").hide();
    });

    jQuery("#cerrar-presencia").click(function () {
        jQuery(".presencia-btn-section").css("max-height", "100px");
        jQuery("#abrir-presencia").show();
    });


    /************** Page editar perfil *********************************/

    function getId(url) {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[2].length === 11) ? match[2] : null;
    }


    function updatePreview() {
        const phone = $("#new_phone").val();
        const whatsapp = $("#new_whatsapp").val();
        const email = $("#new_email").val();
        const web = $("#new_web").val();
        const address = $('#new_address').val() + ' - ' + $('#new_cp').val() + ' ' + $('#new_locality').val() + ' (' + $('#new_province option:selected').text() + ')';
        const intro = $("#new_intro").val().replace(/\n/g, '<br>');
        const long_intro = $("#new_long_intro").val().replace(/\n/g, '<br>');
        const year = $("#new_org_year").val();
        const area = $('#new_area option:selected').text()
        const preocupacion = $("#new_preocupacion").val();
        const videoUrl = $('#new_video').val().trim();

        const platforms = ["facebook", "instagram", "twitter", "linkedin", "youtube"];

        platforms.forEach(function (platform) {
            const value = $(`#new_${platform}`).val();

            if (value !== '') {
                const url = value.startsWith('http') ? value : `https://${value}`;
                $(`#${platform}-preview`).attr("href", url).show();
            } else {
                $(`#${platform}-preview`).hide();
            }
        });


        $("#phone-preview").text(phone);
        $("#whatsapp-preview").text(whatsapp);
        $("#email-preview").text(email);
        $("#web-preview").attr("href", web);
        $("#full-address-preview").text(address);
        $("#intro-preview").html(intro);
        $("#long-intro-preview").html(long_intro);
        $("#year-preview").text(year);
        $("#area-preview").text(area);
        $("#preocupacion-preview").text(preocupacion);

        $('#video-error-message').hide();

        if (videoUrl) {

            var embedUrl = '';

            var videoId = getId(videoUrl);

            // If the video ID is valid, create the embed URL
            if (videoId) {
                embedUrl = 'https://www.youtube.com/embed/' + videoId;
            }
            // Check for Vimeo URLs
            else if (videoUrl.includes('vimeo.com')) {
                var vimeoRegex = /vimeo\.com\/(\d+)/;
                var vimeoMatch = videoUrl.match(vimeoRegex);
                if (vimeoMatch && vimeoMatch[1]) {
                    embedUrl = 'https://player.vimeo.com/video/' + vimeoMatch[1];
                }
            }

            if (embedUrl) {
                // Update iframe src with the generated embed URL
                $('#iframe-preview').attr('src', embedUrl);
            } else {
                // Display an error message for invalid URLs
                $('#video-error-message').text('Invalid video URL. Please use YouTube or Vimeo.').show();
            }
        }

        $('#new_intro_image').on('change', function (event) {
            var file = event.target.files[0];

            if (file) {
                var reader = new FileReader();

                reader.onload = function (e) {
                    $('#image-preview').attr('src', e.target.result);
                };

                reader.readAsDataURL(file);
            }
        });

        $('#new_logo').on('change', function (event) {
            var file = event.target.files[0];

            if (file) {
                var reader = new FileReader();

                reader.onload = function (e) {
                    $('#logo-preview').attr('src', e.target.result);
                };

                reader.readAsDataURL(file);
            }
        });
    }

    jQuery('.toggle-switch').on('change', function () {

        var parent = jQuery(this).closest('.d-flex');

        var editText = parent.find('.edit-text');
        var editIcon = parent.find('.edit-icon');
        var viewText = parent.find('.view-text');
        var viewIcon = parent.find('.view-icon');

        if (jQuery(this).prop('checked')) {

            editText.removeClass('blue-text');
            editIcon.removeClass('blue-icon-edit');
            viewText.addClass('blue-text');
            viewIcon.addClass('blue-icon-view');
            viewIcon.css('opacity', 1);
            editIcon.css('opacity', 0.5);
        } else {

            viewText.removeClass('blue-text');
            viewIcon.removeClass('blue-icon-view');
            editText.addClass('blue-text');
            editIcon.addClass('blue-icon-edit');
            editIcon.css('opacity', 1);
            viewIcon.css('opacity', 0.5);
        }
    });

    function toggleSections(toggleSwitch, editSection, previewSection) {

        $(toggleSwitch).on("change", function () {
            if ($(this).is(":checked")) {
                updatePreview();
                $(editSection).addClass('d-none');
                $(editSection).closest('div.col-md-8').removeClass('col-md-8');
                $(previewSection).removeClass('d-none');
            } else {
                $(editSection).removeClass('d-none');
                $(editSection).closest('div.informacion-general').addClass('col-md-8');
                $(previewSection).addClass('d-none');
            }
        });
    }

    toggleSections(".toggle-switch-1", "#info-general-edit", "#info-general-preview");
    toggleSections(".toggle-switch-2", "#breve-descripcion-edit", "#breve-descripcion-preview");
    toggleSections(".toggle-switch-3", "#breve-intro-edit", "#breve-intro-preview");
    toggleSections(".toggle-switch-4", "#info-extra-edit", "#info-extra-preview");
    toggleSections(".toggle-switch-5", "#video-edit", "#video-preview");
    toggleSections(".toggle-switch-6", "#doc-edit", "#doc-preview");
    toggleSections(".toggle-switch-7", "#image-edit", "#images-preview");

    function handleFormSubmit(formId, buttonId) {
        jQuery(buttonId).on('click', function (e) {
            e.preventDefault();

            let allFilled = true;

            jQuery(formId + ' :input[required]').each(function () {
                var inputField = jQuery(this);
                var errorMsgDiv = inputField.closest('div').find('.error-msg');

                if (inputField.val().trim() === '') {
                    allFilled = false;
                    errorMsgDiv.html('Este campo es obligatorio.').show();
                } else {
                    errorMsgDiv.html('').hide();
                }
            });

            if (!allFilled) {
                return;
            }

            let formData = jQuery(formId).serialize();

            jQuery.ajax({
                url: ajaxurl,
                type: 'POST',
                data: {
                    action: 'update_form_v2',
                    form_data: formData
                },
                success: function (response) {
                    console.log(response);
                    if (response.success) {
                        jQuery(formId + ' .success-msg').text('La información se ha guardado correctamente.').fadeIn(300).delay(2700).fadeOut(300);
                    } else {
                        console.log('Error: ' + response.data.message);
                    }
                },
                error: function () {
                    console.log('An unexpected error occurred.');
                }
            });

            if (formId === '#info-general') {

                let formElement = jQuery(formId)[0];

                let formData = new FormData(formElement);
                formData.append('action', 'save_logo_image');

                var assocId = jQuery('#assoc_id').val();
                formData.append('assoc_id', assocId);

                var nonce = jQuery('#assoc-logo-nonce').val();
                formData.append('security', nonce);

                $.ajax({
                    url: ajaxurl,
                    type: 'POST',
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: function (response) {
                        if (response.success) {
                            console.log(response.data.message);
                        } else {
                            console.log(response.data.message);
                        }
                    },
                    error: function () {
                        console.log('An error occurred. Please try again.');
                    },
                });
            }
        });
    }

    handleFormSubmit('#info-general', '#info-general-submit');
    handleFormSubmit('#breve-descripcion', '#breve-descripcion-submit');
    handleFormSubmit('#quienes-somos', '#quienes-somos-submit');
    handleFormSubmit('#extra-general', '#extra-general-submit');
    handleFormSubmit('#video', '#video-submit');

    jQuery('#info-contacto-submit').on('click', function (e) {
        e.preventDefault();

        let allFilled = true;

        jQuery('#info-contacto' + ' :input[required]').each(function () {
            var inputField = jQuery(this);
            var errorMsgDiv = inputField.closest('div').find('.error-msg');

            if (inputField.val().trim() === '') {
                allFilled = false;
                errorMsgDiv.html('Este campo es obligatorio.').show();
            } else {
                errorMsgDiv.html('').hide();
            }
        });

        if (!allFilled) {
            return;
        }

        let formData = jQuery('#info-contacto').serialize();

        jQuery.ajax({
            url: ajaxurl,
            type: 'POST',
            data: {
                action: 'update_form_account_v2',
                form_data: formData
            },
            success: function (response) {
                console.log(response);
                if (response.success) {
                } else {
                    console.log('Error: ' + response.data.message);
                }
            },
            error: function () {
                console.log('An unexpected error occurred.');
            }
        });
    });


    /***************** Publicación de contenidos *********************/

    $('.selecciona-tipo').on('click', function () {
        $('.tipo-contenido').removeClass('d-none');
        $('.selecciona-tipo').addClass('d-none');
    });

    $('.tipo-noticia-btn').on('click', function () {
        $('.tipo-noticia').removeClass('d-none');
        $('.tipo-articulo, .tipo-evento').addClass('d-none');
        $('.tipo-btn').removeClass('active');
        $(this).addClass('active');
    });

    $('.tipo-articulo-btn').on('click', function () {
        $('.tipo-articulo').removeClass('d-none');
        $('.tipo-noticia, .tipo-evento').addClass('d-none');
        $('.tipo-btn').removeClass('active');
        $(this).addClass('active');
    });

    $('.tipo-evento-btn').on('click', function () {
        $('.tipo-evento').removeClass('d-none');
        $('.tipo-noticia, .tipo-articulo').addClass('d-none');
        $('.tipo-btn').removeClass('active');
        $(this).addClass('active');
    });


    $('#contenido-noticia').on('submit', function (e) {
        e.preventDefault();

        var formData = new FormData(this);
        formData.append('action', 'create_noticia_post');

        var fileInput = $('#new_noticia_file')[0].files[0];
        if (fileInput) {
            formData.append('new_noticia_file', fileInput);
        }

        var mediaInput = $('#new_noticia_media')[0].files[0];
        if (mediaInput) {
            formData.append('new_noticia_media', mediaInput);
        }

        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                if (response.success) {
                    $('#contenido-noticia')[0].reset();
                    $("label").html('Seleccionar archivo <i class="file-upload"></i>');

                    $('#contenido-noticia').after('<div id="success-message" style="background-color: #E0EBEC; border-radius: 6px;" class="p-2 col-md-6">Tu solicitud se ha enviado correctamente.</div>');

                    setTimeout(function () {
                        $('#success-message').fadeOut();
                    }, 5000);
                } else {
                    alert('Error: ' + response.data);
                }
            },
            error: function () {
                alert('An error occurred.');
            }
        });
    });

    $('#contenido-articulo').on('submit', function (e) {
        e.preventDefault();

        var formData = new FormData(this);
        formData.append('action', 'create_articulo_post');

        var fileInput = $('#new_articulo_pdf')[0].files[0];
        if (fileInput) {
            formData.append('new_articulo_pdf', fileInput);
        }

        var mediaInput = $('#media_articulo')[0].files[0];
        if (mediaInput) {
            formData.append('media_articulo', mediaInput);
        }

        var autorInput = $('#img_autor_articulo')[0].files[0];
        if (autorInput) {
            formData.append('img_autor_articulo', autorInput);
        }

        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                if (response.success) {
                    $('#contenido-articulo')[0].reset();
                    $("label").html('Seleccionar archivo <i class="file-upload"></i>');

                    $('#contenido-articulo').after('<div id="success-message" style="background-color: #E0EBEC; border-radius: 6px;" class="p-2 col-md-6">Tu solicitud se ha enviado correctamente.</div>');

                    setTimeout(function () {
                        $('#success-message').fadeOut();
                    }, 5000);
                } else {
                    console.log('Error: ' + response.data);
                }
            },
            error: function () {
                console.log('An error occurred.');
            }
        });
    });

    $('#contenido-evento').on('submit', function (e) {
        e.preventDefault();

        var formData = new FormData(this);
        formData.append('action', 'create_be_event_portal');

        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                if (response.success) {
                    $('#contenido-evento')[0].reset();

                    $('#contenido-evento').after('<div id="success-message" style="background-color: #E0EBEC; border-radius: 6px;" class="p-2 col-md-6">Tu solicitud se ha enviado correctamente.</div>');

                    setTimeout(function () {
                        $('#success-message').fadeOut();
                    }, 5000);
                } else {
                    console.log('Error: ' + response.data);
                }
            },
            error: function () {
                console.log('An error occurred.');
            }
        });
    });

    $('.contenido-btn').on('click', function () {

        $('.contenido-btn').removeClass('active');
        $(this).addClass('active');

        const searchQuery = $('.input-buscador-contenido').val();
        const statusText = $(this).text().trim();
        let status;

        if (statusText === 'Publicadas') {
            status = 'publish';
        } else if (statusText === 'Pendientes de revisión') {
            status = 'draft';
        } else if (statusText === 'Descartadas') {
            status = 'trash';
        }

        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: {
                action: 'filter_posts',
                status: status,
                search_query: searchQuery
            },
            beforeSend: function () {
                $('#post-container').html('<p class="mt-4">Loading...</p>');
            },
            success: function (response) {
                $('#post-container').html(response);
            },
            error: function (xhr, status, error) {
                console.error('AJAX Error:', error);
                $('#post-container').html('<p>Error loading posts.</p>');
            },
        });
    });

    $('.input-buscador-contenido').on('input', function () {
        const searchQuery = $(this).val();
        const statusText = $('.contenido-btn.active').text().trim();
        let statusType;

        if (statusText === 'Publicadas') {
            statusType = 'publish';
        } else if (statusText === 'Pendientes de revisión') {
            statusType = 'draft';
        }

        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: {
                action: 'filter_posts',
                status: statusType,
                search_query: searchQuery,
            },
            success: function (response) {

                $('#post-container').html(response);
            }
        });
    });

    function handleFileInputChange(inputSelector, labelSelector) {
        $(inputSelector).on("change", function () {
            const fileName = $(this).prop("files")[0]?.name || "Seleccionar archivo";
            $(labelSelector).text(fileName);
        });
    }

    handleFileInputChange("#new_noticia_file", "label[for='new_noticia_file']");
    handleFileInputChange("#new_noticia_media", "label[for='new_noticia_media']");
    handleFileInputChange("#new_articulo_pdf", "label[for='new_articulo_pdf']");
    handleFileInputChange("#media_articulo", "label[for='media_articulo']");
    handleFileInputChange("#img_autor_articulo", "label[for='img_autor_articulo']");



    var texto_ampliado = 0;

    $('.ampliar-texto').on('click', function () {

        if (0 == texto_ampliado) {

            var noticia_content_container = $(this).parent().parent().parent();

            noticia_content_container.find('p').each(function () {

                $(this).css('font-size', '1.2em');

            })

            noticia_content_container.find('li').each(function () {

                $(this).css('font-size', '1.2em');

            })

            $(this).text('Reducir texto');

            texto_ampliado = 1;

        }
        else {

            var noticia_content_container = $(this).parent().parent().parent();

            noticia_content_container.find('p').each(function () {

                $(this).css('font-size', '1em');

            })

            noticia_content_container.find('li').each(function () {

                $(this).css('font-size', '1em');

            })

            $(this).text('Ampliar texto');
            texto_ampliado = 0;


        }




    })















    animacion_caja_asociacion_busqueda()






    function animacion_caja_asociacion_busqueda() {




        $('.busqueda .caja-asociacion, .modulo-asociaciones .caja-asociacion').on('mouseenter', function (event) {

            var margin_top = 10;

            var container_top = $(this).offset().top;
            var element_top = $(this).find('.caja-content h3').offset().top - margin_top;

            //$(this).css('justify-content', 'flex-start');

            $(this).find('.caja-imagen').css('opacity', 0);
            $(this).find('.etiquetas-asoc').css('opacity', 0);
            $(this).find('.caja-content').css('transform', 'translateY(-' + (element_top - container_top) + 'px)');
            $(this).find('.caja-description').css('opacity', 1);

        })

        $('.busqueda .caja-asociacion, .modulo-asociaciones .caja-asociacion').on('mouseleave', function () {


            //$(this).css('justify-content', 'flex-start');

            $(this).find('.caja-imagen').css('opacity', 1);
            $(this).find('.etiquetas-asoc').css('opacity', 1);
            $(this).find('.caja-description').css('opacity', 0);
            $(this).find('.caja-content').css('transform', '');

        })

        $('.busqueda .ficha-noticia-title').each(function () {

            var title = $(this)[0];
            $clamp(title, { clamp: 2 });

        })

        $('.busqueda .caja-content h3, .modulo-asociaciones .caja-content h3').each(function () {

            var title = $(this)[0];
            $clamp(title, { clamp: 1 });

        })




    }


    /***** Scripts para el magnifico buscador ******/


    $('.search-button, .search-button-mobile').on('click', function (e) {

        e.preventDefault();
        $('.pop-up-buscador').css('transform', 'translateY(0)');
        setTimeout(function () { $('.pop-up-buscador').css('backdrop-filter', 'blur(40px)') }, 500);
        $('.search-submit').css('opacity', '0.5');
        $('.search-submit').css('pointer-events', 'none');
        $('search_text').click();

    })


    $('.close-search').on('click', function () {


        $('.pop-up-buscador').css('backdrop-filter', 'blur(0px)');

        setTimeout(function () { $('.pop-up-buscador').css('transform', 'translateY(-100%)') }, 500);


    })

    $('.search-submit').on('click', function () {


        var text_search = $('#search_text').val();
        var base_url = window.location.origin;
        window.location.href = base_url + '/buscar/' + encodeURI(text_search);


    })

    $('#search_text').on('keypress', function (e) {

        $('.search-submit').css('opacity', '1');
        $('.search-submit').css('pointer-events', 'auto');
        if (e.which == 13) {

            var text_search = $('#search_text').val();
            var base_url = window.location.origin;
            window.location.href = base_url + '/buscar/' + encodeURI(text_search);


        }


    })


})
